<div *ngIf="showMidRotationReview === false">
    <ion-row>
        <ion-col size="12">
            <ion-card class="enrolled-card card-1">
                <ion-grid fixed class="application-grid">
                    <ion-row>
                        <ion-col size-xs="0" size-sm="0" size-md="0" size-lg="0" size-xl="3">
                            <ion-slides [options]="sliderOpts" pager="true" *ngIf="status?.application?.program?.image.length > 0">
                                <ion-slide *ngFor="let pic of images; let i = index">
                                    <img
                                        class="program-image"
                                        tappable
                                        (click)="openPreview(pic, i)"
                                        [src]="pic | img : status?.application?.program?.state : 'md'"
                                    />
                                </ion-slide>
                            </ion-slides>
                            <ion-slides [options]="sliderOpts" *ngIf="status?.application?.program?.image.length === 0">
                                <ion-slide>
                                    <img class="program-image" [src]="status?.application?.program?.image | img : status?.application?.program?.state : 'md'" />
                                </ion-slide>
                            </ion-slides>
                        </ion-col>
                        <ion-col size="12" size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="6" color="light-teal">
                            <ion-item class="program-mobile-image" lines="none" color="--ion-color-light-teal-2">
                                <ion-thumbnail
                                    slot="start"
                                    tappable
                                    (click)="openPreview(status?.application?.program?.image, 0)"
                                    class="mobile-thumbnail-images"
                                >
                                    <img [src]="status?.application?.program?.image | img : status?.application?.program?.state : 'md'" />
                                </ion-thumbnail>
                                <ion-label class="ion-text-wrap">
                                    <ion-text class="mobile-program-name" color="dark-teal">
                                        <p>{{ status?.application?.program?.name }}</p>
                                        <p>
                                            <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                            Reporting Location:
                                            {{ status?.application?.program?.address }}, {{ status?.application?.program?.city }},
                                            {{ status?.application?.program?.state }}
                                            {{ status?.application?.program?.postalcode }}
                                        </p>
                                        <p>
                                            <ion-icon name="time-outline" size="medium" slot="start" color="secondary"></ion-icon>
                                            Reporting Time:
                                            {{ status?.user?.application?.program?.reportingtime }}
                                        </p>
                                        <p>
                                            <fa-icon [icon]="faUserMd" slot="start" style="color: var(--ion-color-secondary); padding-right: 0.2em"></fa-icon>
                                            Reporting Physician:
                                            {{ status?.user?.application?.program?.host?.name }}
                                        </p>
                                        <p>
                                            <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                            Clinical Experience:
                                            {{ status?.user?.application?.program?.exposuretype }}
                                        </p>
                                    </ion-text>
                                </ion-label>
                            </ion-item>
                            <ion-list lines="none" class="program-info-card program-details-list-desktop">
                                <ion-item style="width: 31em" color="light-teal">
                                    <ion-label class="ion-text-wrap program-details-label">
                                        <ion-text color="dark-teal" class="section-title">
                                            {{ status?.user?.application?.program?.name }}
                                        </ion-text>
                                        <div class="program-title-padding">
                                            <ion-text color="dark-teal">
                                                <p>
                                                    <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                                    Reporting Location:
                                                    {{ status?.application?.program?.address }}, {{ status?.application?.program?.city }},
                                                    {{ status?.application?.program?.state }}
                                                    {{ status?.application?.program?.postalcode }}
                                                </p>
                                                <p>
                                                    <ion-icon name="time-outline" size="medium" slot="start" color="secondary"></ion-icon>
                                                    Reporting Time:
                                                    {{ status?.user?.application?.program?.reportingtime }}
                                                </p>
                                                <p>
                                                    <fa-icon
                                                        [icon]="faUserMd"
                                                        slot="start"
                                                        style="color: var(--ion-color-secondary); padding-right: 0.2em"
                                                    ></fa-icon>
                                                    Reporting Physician:
                                                    {{ status?.user?.application?.program?.host?.name }}
                                                </p>
                                            </ion-text>
                                        </div>
                                        <div class="program-title-padding">
                                            <ion-text color="dark-teal">
                                                <p>
                                                    <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                                    Clinical Experience:
                                                    {{ status?.user?.application?.program?.exposuretype }}
                                                </p>
                                            </ion-text>
                                        </div>
                                        <div class="program-title-padding program-description"></div>
                                    </ion-label>
                                </ion-item>
                            </ion-list>
                        </ion-col>
                    </ion-row>
                    <ion-row> </ion-row>
                </ion-grid>
            </ion-card>
        </ion-col>
    </ion-row>
    <ion-segment (ionChange)="segmentChanged($event)" value="checklist" mode="md">
        <ion-segment-button value="checklist" mode="md">
            <ion-label class="segment-label">First-Day Checklist</ion-label>
        </ion-segment-button>
        <ion-segment-button value="documents" mode="md">
            <ion-label class="segment-label">Documents</ion-label>
        </ion-segment-button>
    </ion-segment>

    <ion-row *ngIf="promptForMidRotationReview">
        <ion-col size="12">
            <div>
                <ion-card class="card-1 list-card" style="margin-bottom: 1em">
                    <ion-label class="section-title" color="secondary">
                        <ion-text>
                            <h2 class="ion-text-center ion-text-wrap">Complete Your Mid-Rotation Review</h2>
                        </ion-text>
                    </ion-label>
                    <ion-card-content>
                        <div class="ion-text-center">
                            <ion-text>
                                <p>You have completed half of your clinical experience. Let us know how things are going.</p>
                                <ion-button (click)="submitMidRotationReview()">
                                    <ion-text class="ion-text-wrap bold"> Complete Review </ion-text>
                                </ion-button>
                            </ion-text>
                        </div>
                    </ion-card-content>
                </ion-card>
            </div>
        </ion-col>
    </ion-row>

    <app-firstday-checklist *ngIf="showChecklist" [application]="status?.application"></app-firstday-checklist>
    <app-general-documents *ngIf="showDocuments" [status]="status"></app-general-documents>
</div>

<app-review *ngIf="showMidRotationReview === true" [reviewType]="reviewType" [status]="status"></app-review>
